




















































































































































































































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Contatto } from '@/data/models/contatto.model';
import { Comune } from '@/data/models/comune.model';
import { Provincia } from '@/data/models/provincia.model';
import { Search } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { CampaignContact } from '@/data/models/campaign.model';
import { cloneDeep } from 'lodash';
import { currencyToNumber, numberMask } from '@/data/utils/helper';
import store, { State } from '@/store';
import { Headquarter } from '@/data/models/headquarter.model';
import { OfferPayMode } from '@/data/models/offer.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class CallCenterConfirm extends Vue {
	@Prop() model!: CampaignContact;

	@Inject('CrudService') contattoCrudService!: CrudService<Contatto>;
	@Inject('CrudService') provinciaCrudService!: CrudService<Provincia>;
	@Inject('CrudService') comuneCrudService!: CrudService<Comune>;

	newModel!: CampaignContact;

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;
	comuneSearch: Search = new Search('comuni');
	provincia: Provincia | null = null;
	comune: Comune | null = null;

	numberMask: any = numberMask();

	currencies: any = {};

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.newModel = new CampaignContact();
	}

	beforeMount() {
		this.newModel = cloneDeep(this.model);
		this.newModel.address = this.newModel.contact.address;
		this.newModel.streetno = this.newModel.contact.streetno;
		this.newModel.province = this.newModel.contact.province;
		this.newModel.comune = this.newModel.contact.comune;
		this.newModel.city = this.newModel.contact.city;
		this.newModel.zipcode = this.newModel.contact.zipcode;
		this.newModel.note = undefined;
		this.newModel.paymode = OfferPayMode.PAYMENT_METHOD_CASH;
		this.loadProvince();
		this.loadComuni();
	}

	loadProvince() {
		const search = new Search('province');
		search.addSimpleFilter('descrizione', this.newModel.province as string);
		this.provinciaCrudService
			.searchEntities(Provincia, 'province', search, new Page(10))
			.then(result => this.provincia = result[0]);
	}

	loadComuni() {
		if (!this.newModel.province) return;
		const search = new Search('comuni');
		search.addSimpleFilter('provincia', this.newModel.province);
		search.addSimpleFilter('descrizione', this.newModel.comune as string);
		this.comuneCrudService
			.searchEntities(Comune, 'comuni', search, new Page(100))
			.then(result => this.comune = result[0]);
	}

	onProvinciaChange() {
		if (this.provincia) {
			this.newModel.province = this.provincia.descrizione;
			this.newModel.comune = undefined;
			this.comuneSearch.addSimpleFilter('provincia', this.provincia.descrizione as string);
		}
	}

	onComuneChange() {
		if (this.comune) this.newModel.comune = this.comune.descrizione;
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	submit() {
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.newModel, k, this.currencies[k]);
		});
		this.$emit('submit', this.newModel);
	}

	close() {
		(this.$parent as any).close();
	}

	get headquarter(): Headquarter {
		return this.state.headquarter as Headquarter;
	}

}
